import axios from "axios";
import {Base_URL} from "../url"

export const fetchVendorInvoiceApprovalData = async () => {
    try {
      const response = await axios.get(`${Base_URL}/VendorInvoiceApproval/VendorInvoiceApproval`);
      return response.data;
    } catch (error) {
      console.error("Error fetching vendor invoice approval data:", error);
      throw error;
    }
  };
  
  export const sendVendorInvoiceApprovalRequest = async (invoiceId, userId) => {
    try {
      await axios.put(`${Base_URL}/VendorInvoiceApproval/UpdateInvoiceApproval?InvoiceId=${invoiceId}&UserId=${userId}`);
    } catch (error) {
      console.error("Error sending vendor invoice approval request:", error);
      throw error;
    }
  };